import Cookie from 'js-cookie'

const DOMAIN = process.env.REACT_APP_COOKIE_DOMAIN
const COOKIE_NAME = 'easybutton_session'

export const setCookie = () => {
  Cookie.set(COOKIE_NAME, 1, { domain: DOMAIN })
}

export const removeCookie = () => {
  Cookie.remove('easybutton_session', { domain: DOMAIN })
}
